// Centralised contact data for Royal Pets Veterinaria
export const CLINIC = {
  name: "Royal Pets Veterinaria",
  shortName: "Royal Pets",
  phoneDisplay: "+56 9 5371 8072",
  phoneTel: "+56953718072",
  whatsappNumber: "56953718072", // for wa.me links
  whatsappMessage: "Hola Royal Pets, necesito atención para mi mascota.",
  whatsappEmergencyMessage: "Hola Royal Pets, tengo una urgencia 24/7 con mi mascota.",
  address: "Alberto Arenas 2869, La Serena, Coquimbo",
  zip: "1721734",
  city: "La Serena",
  region: "Coquimbo, Chile",
  hours: "Atención 24/7",
  instagramUrl: "https://www.instagram.com/royalpetsveterinaria/",
  instagramHandle: "@royalpetsveterinaria",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Royal+Pets+Veterinaria+Alberto+Arenas+2869+La+Serena",
  mapEmbedUrl:
    "https://www.google.com/maps?q=Alberto%20Arenas%202869%2C%20La%20Serena%2C%20Coquimbo%2C%20Chile&output=embed",
};

export const waLink = (msg = CLINIC.whatsappMessage) =>
  `https://wa.me/${CLINIC.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${CLINIC.phoneTel}`;
